import { MailOpen } from "lucide-react";
import { useState, useEffect } from "react";
import Navbar from "../../../components/layout/Navbar";
import { Link } from "react-router-dom";
import { useTokenRefreshMutation } from "../../../services/authApi";
import { toast } from "sonner";

const CheckReset = () => {
  const [email, setEmail] = useState<string>("");
  const [tokenRefresh, { isLoading }] = useTokenRefreshMutation();

  const [hasResentMail, setHasResentMail] = useState(false);

  useEffect(() => {
    // Get email from local storage that was set in the ResetPassword component
    const storedEmail = localStorage.getItem("resetEmail");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  const handleResendEmail = async () => {
    if (hasResentMail) {
      toast.error(
        "You have already resent the reset email. Wait a few minutes before trying again."
      );
      return;
    }
    if (email) {
      try {
        await tokenRefresh(email).unwrap();
        // Could add a success message here
        toast.success("Email sent successfully");

        setHasResentMail(true)

        setTimeout(() => {
          setHasResentMail(false);
        }, 5 * 60 * 1000); // 5 minutes
      } catch (error: unknown) {
        if (typeof error === "object" && error !== null && "data" in error) {
          const err = error as { data?: Record<string, string[]> };
          toast.error(
            Object.entries(err.data as Record<string, string[]>)
              .map(([_, value]) => value)
              .join(", ") || "Failed to send email"
          );
        }
        console.error("Failed to send email:", error);
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div className="p-5 sm:p-14 h-[81vh] flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2 className=" flex items-center justify-center gap-2">
                Check email <MailOpen />
              </h2>
              <div className="flex flex-col items-start justify-center gap-10 w-full">
                <p className="flex items-center justify-start">
                  A password reset email has been sent to:{" "}
                  <span className="font-medium">{email}</span>
                </p>
                <p className="flex items-center justify-center gap-1">
                  Haven't seen email or wrong email?
                  <span
                    className="text-[#945bf5] cursor-pointer"
                    onClick={handleResendEmail}
                  >
                    {isLoading ? "Sending..." : "Send new"}
                  </span>
                  or
                  <Link to="/reset-password" className="text-[#945bf5]">
                    {" "}
                    edit email
                  </Link>
                </p>
              </div>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%]  items-center justify-end mt-1 ">
            <Link to="">
              <li>Help</li>
            </Link>
            <Link to="">
              <li>Privacy</li>
            </Link>
            <Link to="">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CheckReset;
